import util from "csi/util";
import Query from "csi/xml/Query";
import { IDataStoreSort } from "src/c8-platform/type/dataStore";

/** parse Sort element into object */
export function parseSort(element: Element): IDataStoreSort {
	const id = util.getProperty(element, "Id");
	const prop = util.getProperty(element, "Property");
	const path = util.getProperty(element, "Path");
	const descending = !util.getBooleanProperty(element, "Dir", true);

	return {
		descending,
		id,
		path,
		prop,
	};
}

/** apply sort objects to the query */
export function processSorts(sorts: IDataStoreSort[], query: Query): Query {
	sorts?.forEach(({ descending, id, path, prop }) => {
		if (prop) {
			query.SortByNode(prop, path, descending);
		} else {
			query.SortByAttr(id, path, null, descending);
		}
	});

	return query;
}
